interface NavLinkItem {
  name: string;
  href: string;
}

export const navigation: NavLinkItem[] = [
  { name: 'Home', href: '/' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'Get a Demo', href: '/book-demo' },
  { name: 'Support', href: '/support' },
  { name: 'Documentation', href: 'https://docs.flagsync.com/' },
];
